/* eslint-disable jsx-a11y/accessible-emoji */
import React, {
    useEffect,
    useState,
    useRef,
    useCallback,
} from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { useParams, useHistory } from 'react-router-dom';
import Observer from 'react-intersection-observer';
import PropTypes from 'prop-types';
import _, { result } from 'lodash';
import classNames from 'classnames';
import { Box, Checkbox, Popover } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import {
    MEDIA_TYPE, EVENT_EFFECT_DURATION, BOOTH_TYPE,CateGetNameOfCategoryByFirstStr,
} from '../../common/Constants';
import {
    VideoCam, Image, HeadsetIcon, PlayIcon, RadioButtonIcon,
} from '../../components/Icons/Icon';
import Button from '../../components/Button/CustomButton';
import GridContainer from '../../components/Grid/GridContainer';
import GridItem from '../../components/Grid/GridItem';
import Pagination from '../../components/Pagination/Pagination';
import RegisterLinks from '../../components/RegisterLinks/RegisterLinks';
import SelectorInput from '../../components/Input/SelectorInput';
import Snackbar from '../../components/Snackbar/Snackbar';
import Table from './OrganizerListTable';
import Typography from '../../components/Typography/CustomTypography';
import CleanableInput from '../../components/Input/CleanableInput';
import Loader from '../../components/Loader/Loader';
import { navyColor } from '../../assets/jss/global';
import { convertZoneArrayToObject } from '../../common/helper/convertZoneArrayToObject';
import Switch from '../../components/Switch/Switch';

import styles from '../../assets/jss/pages/organizerListPageStyle';
import Advertisement from '../../components/Advertisement/Advertisement';

import { convertDuration, isAfterEnd30Day, isBeforeStart14Day ,
  isBeforeUsingStartXdays, isAfterUsingEndXdays } from '../../utils/dateUtils';
import FreeLogin from '../../components/FreeEntrance/FreeLogin';
import OrganizerListCustomLayoutFirst from './OrganizerListCustomLayoutFirst';

const useStyles = makeStyles(styles);
const VIEW_MODE = {
    ICON_LIST: false,
    TABLE: true,
};

export const Header = (props) => {
    const {
        eventInfo,
        isAuthorized,
        isWeakAuth,
        companyIDs,
        selectedOrganizerList,
        getEventProducts,
        getEventProductsBigZone,
        getEventProductsSmallZone,
        getEventProductsStandardZone,
        getEventProductsGrandZone,
        jobs,
        category,
        zones,
        setSearchCondition,
        viewMode,
        setViewMode,
        customText,
         /*  ★★ */
        customTimerctrl,
        
        clearEventProducts,
        clearEventProductsBigZone,
        clearEventProductsSmallZone,
        clearEventProductsStandardZone,
        clearEventProductsGrandZone,

        clearCompanyList,
        getCompaniesByEvent,
        language,
        locale,
        langOther,
    } = props;
    const classes = useStyles(props);
    const intl = useIntl();
    const history = useHistory();
    const { shortName } = useParams();
    const searchData = useRef({});
    const [selectedOrganizers, setSelectedOrganizers] = useState({});
    const [openSearchPop, setOpenSearchPop] = useState(false);
    const [jobStates, setJobState] = useState({});
    const [categoryheadState, setCategoryheadState] = useState({});
    const [zonesState, setZonesState] = useState({});
    const [anchorEl, setAnchorEl] = useState(null);
    const [showSearch, setShowSearch] = useState(false);
    const [tokuTempo, setTokuTempo] = useState("");

    useEffect(() => {
        if (eventInfo.sdate) {
            const startDateDifference = getDifferenceInDays(null, eventInfo.sdate);
            if (startDateDifference <= EVENT_EFFECT_DURATION.BEFORE) {
                if (isAuthorized) {
                    if (companyIDs.length) {
                        const selected = {};
                        companyIDs.forEach((id) => { selected[id] = true; });
                        setSelectedOrganizers(selected);
                    }
                }
            }
        }
    }, [companyIDs, eventInfo, isAuthorized]);

    useEffect(() => {
        if (!_.isEmpty(selectedOrganizerList)) {
            setSelectedOrganizers(selectedOrganizerList);
        }
    }, [selectedOrganizerList]);

    useEffect(() => {
        if (langOther !== 'English' && langOther !== '日本語' && langOther !== '') {
            setShowSearch(true);
        } else setShowSearch(false);
    }, [langOther]);

    useEffect(() => {
        if (!_.isEmpty(zones)) {
            searchData.current = {};
            if (!_.isEmpty(category)) {
                searchData.current.category = '';
            }
            searchData.current.zone_id = '';
        } else {
            searchData.current = {};
        }
    }, [locale]);

    useEffect(() => {
        if (!_.isEmpty(jobs)) {
            setJobState(_.reduce(jobs, (result, value) => ({ ...result, [value]: value }), { '': '' }));
        }
    }, [jobs]);
    useEffect(() => {
        if (!_.isEmpty(category)) {
            setCategoryheadState(prevState => {
                
                const newState = _.reduce(category, (result, value) => ({ ...result, [value]: value }), { 'allXXXCategory': '' });
                return _.isEqual(prevState, newState) ? prevState : newState;
            });
        } 
    }, [category]);   

    useEffect(() => {
        if (!_.isEmpty(zones)) {
            let zonesObj = {};

            if (zones.length > 1) {
                zonesObj = convertZoneArrayToObject([{ id: '', name: intl.formatMessage({ id: 'exhibition.zone' }) }, ...zones]);
                searchData.current.zone_id = '';
            } else {
                zonesObj = convertZoneArrayToObject(zones);
                searchData.current.zone_id = zones[0].name;
            }

            setZonesState(zonesObj);
        }
    }, [zones]);



    const handleSetSearchData = (field, value) => {
        searchData.current[field] = value;
    };

    const handleSearch = () => {
        setSearchCondition(searchData.current);
        //console.log( "searchData.current is ...");
        //console.log( searchData.current);

        setOpenSearchPop(false);
        //console.log( "eventInfo.layout_exhibitionとはなんでしょうね・・・,");
        //console.log( eventInfo.layout_exhibition);
    

        if( searchData?.current?.category ){
 
            // 分類 categoryでの抽出・検索。
            //category=[searchData.current.category];
            //console.log("OK click category choose" + searchData.current.category );
            //setCategoryState(_.reduce(category, (result, value) => ({ [searchData.current.category]: searchData.current.category })));
            //choseCategoryState =[] ;
            clearEventProducts();
            searchData.current["page_size"]=100000; 
            getEventProducts(shortName, searchData.current, locale);
            clearCompanyList();
            getCompaniesByEvent(shortName, searchData.current, locale);  // ★2024-2-16 add 
            return;
        }else{
            handleSetSearchData('category', "allXXXCategory");

        }
        if (!eventInfo.layout_exhibition) {
            if (eventInfo.has_zone) {
                //console.log("Ln194.." + searchData.current );
                clearEventProducts();
                getEventProducts(shortName, searchData.current, locale);
                return;
            }
            if (eventInfo.big_zone){
                //console.log("Ln200.." );console.log(searchData.current );
                clearEventProductsBigZone();
                getEventProductsBigZone(shortName, searchData.current, locale);
            }
            if (eventInfo.small_zone){
                //console.log("Ln205..");console.log(searchData.current );
                clearEventProductsSmallZone();
                getEventProductsSmallZone(shortName, searchData.current, locale);
            }
            if (eventInfo.standard_zone){
                //console.log("Ln210..");console.log(searchData.current );
                clearEventProductsStandardZone();
                getEventProductsStandardZone(shortName, searchData.current, locale);
            }
            if (eventInfo.grand_zone){
                //console.log("Ln215..");console.log(searchData.current );
                clearEventProductsGrandZone();
                getEventProductsGrandZone(shortName, searchData.current, locale);
            }

        } else {
            clearEventProducts();
            getEventProducts(shortName, searchData.current, locale);
            clearCompanyList();
            getCompaniesByEvent(shortName, searchData.current, locale);
        
        }
    };

    const handleBrowse = () => {
        history.push(`/${shortName}/exhibitor-posters`);
    };

    const getSelectedOrganizersAsArray = (value) => {
        const selected = Object.keys(value).reduce((acc, key) => {
            if (value[key]) acc.push(key);
            return acc;
        }, []);
        return selected;
    };

    const isSearchButtonDisabled = () => {
        if (!getSelectedOrganizersAsArray(selectedOrganizers).length) return true;
/* 
        if (!isBeforeStart14Day(eventInfo.sdate) && !isAfterEnd30Day(eventInfo.edate)) return false;
 */
        if ( ! isBeforeUsingStartXdays( 
               eventInfo.sdate, 
                (customTimerctrl && customTimerctrl.hasOwnProperty("TC_exhlist_before") && customTimerctrl.TC_exhlist_before )
                	? customTimerctrl.TC_exhlist_before 
                	: 14 
                )
               &&
            ! isAfterUsingEndXdays(
            	  eventInfo.edate,
            	  (customTimerctrl && customTimerctrl.hasOwnProperty("TC_exhprod_after") && customTimerctrl.TC_exhprod_after ) 
            	  ? customTimerctrl.TC_exhprod_after 
            	  : 30 
                 ) 
          ){
		   return false;
          }
        
        return true;
    };

    const getDifferenceInDays = (start, end) => {
        const startDate = start ? new Date(start) : new Date();
        startDate.setHours(0, 0, 0, 0);
        const endDate = end ? new Date(end) : new Date();
        endDate.setHours(0, 0, 0, 0);
        return (endDate - startDate) / 86400000;
    };

    const handleOpenPopSearch = (event) => {
        if( tokuTempo==="" && !_.isEmpty(category)){
            setTokuTempo("1");
            handleSearch();
        }

        setAnchorEl(event.currentTarget);
        setOpenSearchPop(true);
    };

    const renderSearchRow = (label, content) => (
        <GridContainer spacing={3} className={classes.popperSearch}>
            <GridItem xs={12} sm={4} md={2} className={classes.searchLabel}>
                <Typography bold customColor={eventInfo?.settings_colors_viewer?.contents_text_color}>
                    <FormattedMessage id={label} />
                </Typography>
            </GridItem>
            <GridItem xs={12} sm={8} md={10}>
                {content}
            </GridItem>
        </GridContainer>
    );

    const renderSearch = () => (
        <>
            {renderSearchRow(
                customText?.field_name?.exhibitor_participants || 'companyName',
                <CleanableInput
                    classes={{ root: classes.colorTextInput }}
                    defaultValue={searchData.current.company}
                    placeholder={
                        intl.formatMessage({ id: 'organizerList.placeholder.company' },
                            {
                                companyName: `${customText?.field_name?.exhibitor_participants
                                    || intl.formatMessage({ id: 'exhibition.companyName' }).toLocaleLowerCase()}`,
                            })
                    }
                    onChange={(value) => handleSetSearchData('company', value)}
                />,
            )}
            {!(eventInfo.layout_exhibition === 1 && !viewMode) && renderSearchRow(
                customText?.field_name?.product_name || 'product',
                <CleanableInput
                    classes={{ root: classes.colorTextInput }}
                    defaultValue={searchData.current.product}
                    placeholder={
                        intl.formatMessage({ id: 'organizerList.placeholder.product' },
                            {
                                product: `${customText?.field_name?.product_name || intl.formatMessage({ id: 'exhibition.merchandise' })}`,
                            })
                    }
                    onChange={(value) => handleSetSearchData('product', value)}
                />,
            )}
            {eventInfo.has_zone && renderSearchRow(
                customText?.field_name?.zone || 'zone',
                <SelectorInput
                    isCustomColor={eventInfo.has_customize}
                    customColor={eventInfo?.settings_colors_viewer?.contents_text_color}
                    valueSelected={searchData.current.zone_id}
                    optionList={zonesState}
                    onChange={(value) => handleSetSearchData('zone_id', value)}
                    sortType="asc"
                />,
            )}
            {renderSearchRow(
                customText?.field_name?.industry || 'industryType',
                <SelectorInput
                    isCustomColor={eventInfo.has_customize}
                    customColor={eventInfo?.settings_colors_viewer?.contents_text_color}
                    valueSelected={searchData.current.type}
                    optionList={jobStates}
                    onChange={(value) => handleSetSearchData('type', value)}
                />,
            )}
            {
            
            category?.length >=1 && renderSearchRow(
                ( category[0] ? CateGetNameOfCategoryByFirstStr[category[0]] : "分類" ),
                <SelectorInput
                    isCustomColor={eventInfo.has_customize}
                    customColor={eventInfo?.settings_colors_viewer?.contents_text_color}
                    valueSelected={searchData.current.category}
                    optionList={categoryheadState}
                    onChange={(value) => handleSetSearchData('category', value)}

                />,
                )
                
            }

            <Box textAlign="right" paddingBottom={1} paddingLeft={1} paddingRight={1}>
                <Button
                    color="navy"
                    size="md"
                    onClick={handleSearch}
                    buttonTextColor={eventInfo?.settings_colors_viewer?.button_text_color}
                    buttonBackgroundColor={eventInfo?.settings_colors_viewer?.button_background_color?.common_button}
                >
                    {customText?.button_name?.search || intl.formatMessage({ id: 'search' })}
                </Button>
            </Box>
        </>
    );
    return (
        <>
            {!_.isEmpty(eventInfo) && (
                <>
                    <Box display="flex" flexDirection="column" style={{ width: '100%' }}>
                        <Typography
                            variant="h5"
                            bold
                            align="right"
                            color="event"
                            customColor={eventInfo?.settings_colors_viewer?.event_name_text_color}
                              >
                            {eventInfo.name}
                        </Typography>
                        <Typography
                            bold
                            variant="h4"
                            color="navy"
                            align="center"
                            style={{ padding: '8px 0' }}
                            customColor={eventInfo?.settings_colors_viewer?.screen_name_text_color}
                        >
                            {eventInfo?.settings_texts_sidebar_viewer?.field_name?.exhibitor_info_list || intl.formatMessage({ id: 'userRoutes.organizerListNewName' })}
                        </Typography>
                        <GridContainer style={{ justifyContent: eventInfo.layout_exhibition === 0 ? 'center' : 'end' }}>
                            {( category?.length >= 1 || (viewMode && eventInfo.layout_exhibition === 0)) && (
                                <GridItem xs={12} sm={12} md={4} style={{ padding: '4px 20px 0px' }}>
                                    <ul className={classes.customList}>
                                        { (shortName=="test001" || shortName=="JPL24" )  && (
                                        <>
                                        <li>本情報は企画宣伝用に制作されたデモ用情報です。</li>
                                        <li>本サイトの立地情報は各自治体の立地情報サイトより参照し、デモ用として作成したものです。一般的なネット検索で表示されることはありません。</li>
                                        </>    
                                        )}
                                        <li>
                                            <Typography
                                                variant="body1"
                                                customColor={eventInfo?.settings_colors_viewer?.contents_text_color}
                                            >
                                                {intl.formatMessage({ id: 'exhibition.noteViewProduct' },
                                                    {
                                                        directSelection: `${customText?.button_name?.direct_selection || intl.formatMessage({ id: 'directToDetailProduct' })}`,
                                                        buttonSee: `${eventInfo?.settings_texts_sidebar_viewer?.field_name?.list_companies_want_see
                                                            || intl.formatMessage({ id: 'organizerPosterList.listCompany' })}`,
                                                    })}
                                            </Typography>
                                        </li>
                                        {!showSearch && (
                                            <li>
                                                <Typography variant="body1" customColor={eventInfo?.settings_colors_viewer?.contents_text_color}>
                                                    {intl.formatMessage({ id: 'exhibition.search' },
                                                        {
                                                            companyName: `${customText?.field_name?.exhibitor_participants
                                                                || intl.formatMessage({ id: 'exhibition.companyName' }).toLocaleLowerCase()}`,
                                                            merchandise: `${customText?.field_name?.product_name || intl.formatMessage({ id: 'product' })}`,
                                                            industry: `${customText?.field_name?.industry || intl.formatMessage({ id: 'exhibition.industry' })}`,
                                                        })}
                                                </Typography>
                                            </li>
                                        )}
                                    </ul>
                                </GridItem>
                            )}
                            <GridItem xs={12} sm={12} md={4} className={classes.headerCenterButton} style={{ padding: '4px 0' }}>
                                {(isAuthorized && (!isWeakAuth || isWeakAuth === '') ) && (
                                    <Button
                                        color="navy"
                                        onClick={handleBrowse}
                                        disabled={isSearchButtonDisabled()}
                                        round
                                        className={classes.buttonBig}
                                        size="md"
                                        buttonTextColor={eventInfo?.settings_colors_viewer?.button_text_color}
                                        buttonBackgroundColor={eventInfo?.settings_colors_viewer?.button_background_color?.common_button}
                                    >
                                        {customText?.button_name?.lis_companies_want_see || intl.formatMessage({ id: 'browse.listOfCompany' })}
                                    </Button>
                                )}
                            </GridItem>
                            {( category?.length >= 1 || viewMode || eventInfo?.layout_exhibition === 1) && (
                                <GridItem
                                    xs={12}
                                    sm={12}
                                    md={4}
                                    className={classNames(classes.searchWrapper,
                                        { [classes.hiddenSearchWrapper]: showSearch })}
                                >
                                    <Box display="flex" flexDirection="row" alignItems="center" marginLeft="auto">
                                        {(!viewMode && eventInfo?.layout_exhibition === 1) && (
                                            <Typography
                                                variant="h5"
                                                align="right"
                                                style={{ fontSize: '21px' }}
                                                customColor={eventInfo?.settings_colors_viewer?.contents_text_color}
                                            >
                                                {intl.formatMessage({ id: 'exhibition.searchCompanyName' }, {
                                                    companyName: customText?.field_name?.exhibitor_participants || intl.formatMessage({ id: 'exhibition.companyName' }),
                                                })}
                                                {' '}
                                                {zones?.length
                                                    ? intl.formatMessage({ id: 'zone.industry' }, {
                                                        zone: customText?.field_name?.zone || intl.formatMessage({ id: 'zone' }).toLocaleLowerCase(),
                                                        industryType: customText?.field_name?.industry || intl.formatMessage({ id: 'industryType' }).toLocaleLowerCase(),
                                                    })
                                                    : (`${customText?.field_name?.industry || intl.formatMessage({ id: 'industryType' }).toLocaleLowerCase()}`)}
                                            </Typography>
                                        )}
                                        {!(!viewMode && eventInfo?.layout_exhibition === 1) && (
                                            <Typography
                                                variant="h5"
                                                align="right"
                                                style={{ fontSize: '21px' }}
                                                customColor={eventInfo?.settings_colors_viewer?.contents_text_color}
                                            >
                                                {intl.formatMessage({ id: 'exhibition.searchCompany' }, {
                                                    companyName: customText?.field_name?.exhibitor_participants || intl.formatMessage({ id: 'exhibition.companyName' }),
                                                    merchandise: customText?.field_name?.product_name || intl.formatMessage({ id: 'product' }).toLocaleLowerCase(),
                                                })}
                                                {' '}
                                                <br />
                                                {' '}
                                                {zones?.length
                                                    ? intl.formatMessage({ id: 'zone.industry' }, {
                                                        zone: customText?.field_name?.zone || intl.formatMessage({ id: 'zone' }),
                                                        industryType: customText?.field_name?.industry || intl.formatMessage({ id: 'industryType' }).toLocaleLowerCase(),
                                                    })
                                                    : (`${customText?.field_name?.industry || intl.formatMessage({ id: 'industryType' })}`)}
                                                {
                                                    (category?.length>=1 ) && (
                                                        <Typography
                                                        variant="h5"
                                                        align="right"
                                                        style={{ fontSize: '21px' }}
                                                                 
                                                        >
                                                        { ( category[0] ? CateGetNameOfCategoryByFirstStr[category[0]] : "分類" ) }

                                                        </Typography>


                                                    ) 



                                                }
                                            </Typography>
                                        )}
                                        <PlayIcon color="#cc0000" />
                                        <Button onClick={handleOpenPopSearch} className={classes.searchingButton}>
                                            <img src="/resources/search-15-48.png" alt="" className={classes.imgSearchIcon} />
                                        </Button>
                                        <Popover
                                            open={openSearchPop}
                                            anchorEl={anchorEl}
                                            onClose={() => setOpenSearchPop(false)}
                                            classes={{
                                                paper: classes.searchPaper,
                                            }}
                                            anchorOrigin={{
                                                vertical: 'center',
                                                horizontal: 'left',
                                            }}
                                            transformOrigin={{
                                                vertical: 'center',
                                                horizontal: 'center',
                                            }}
                                        >
                                            {renderSearch()}
                                        </Popover>
                                    </Box>
                                </GridItem>
                            )}
                        </GridContainer>

                       { ( category?.length < 1 ) && (
                        <div className={classes.switchWrapper}>
                            <span className={classes.switchLabel}>
                                {
                                   intl.formatMessage({ id: 'switchViewMode' },
                                    {
                                        companyName: customText?.field_name?.exhibitor_participants || intl.formatMessage({ id: 'exhibition.exhibitorParticipants' }),
                                        productName: customText?.field_name?.product_name || intl.formatMessage({ id: 'exhibition.productName' }),
                                    })
                                }
                            </span>
                            <Switch
                                isChecked={viewMode}
                                handleChange={() => {
                                    setViewMode(!viewMode);
                                }}
                            />
                        </div>
                       )}
                    </Box>
                </>
            )}
        </>
    );
};

Header.defaultProps = {
    eventInfo: {},
    selectedOrganizerList: {},
    isAuthorized: false,
    companyIDs: [],
    jobs: [],
    category: [],
    zones: [],
    setSearchCondition: () => { },
    customText: {},
    customTimerctrl : {},
    
    clearEventProducts: () => {},
    clearEventProductsBigZone: () => {},
    clearEventProductsSmallZone: () => {},
    clearEventProductsStandardZone: () => {},
    clearEventProductsGrandZone: () => {},
    clearCompanyList: () => {},
    getCompaniesByEvent: () => {},
    language: '',
    locale: 'ja',
    langOther: '',
};

Header.propTypes = {
    eventInfo: PropTypes.oneOfType([() => null, PropTypes.object]),
    selectedOrganizerList: PropTypes.oneOfType([() => null, PropTypes.object]),
    isAuthorized: PropTypes.bool,
    companyIDs: PropTypes.arrayOf(PropTypes.number),
    jobs: PropTypes.oneOfType([() => null, PropTypes.array]),
    category: PropTypes.oneOfType([() => null, PropTypes.array]),
    zones: PropTypes.oneOfType([() => null, PropTypes.array]),
    getEventProducts: PropTypes.func.isRequired,
    getEventProductsBigZone: PropTypes.func.isRequired,
    getEventProductsSmallZone: PropTypes.func.isRequired,
    getEventProductsStandardZone: PropTypes.func.isRequired,
    getEventProductsGrandZone: PropTypes.func.isRequired,
    setSearchCondition: PropTypes.func,
    viewMode: PropTypes.bool.isRequired,
    setViewMode: PropTypes.func.isRequired,
    customText: PropTypes.oneOfType([() => null, PropTypes.object]),
    customTimerctrl :PropTypes.oneOfType([() => null, PropTypes.object]),
    
    clearEventProducts: PropTypes.func,
    clearEventProductsBigZone: PropTypes.func,
    clearEventProductsSmallZone: PropTypes.func,
    clearEventProductsStandardZone: PropTypes.func,
    clearEventProductsGrandZone: PropTypes.func,


    clearCompanyList: PropTypes.func,
    getCompaniesByEvent: PropTypes.func,
    language: PropTypes.string,
    locale: PropTypes.string,
    langOther: PropTypes.string,
};

const OrganizerList = ({
    eventInfo, isLoading, isAuthorized, companyIDs,
    allProducts4Cate,
    allProducts,
    successGetProducts,
    errorsGetProducts,
    getEventProducts,
    clearEventProducts,
    updateFavoriteCompanies, getFavoriteCompanies, clearFavoriteCompanies, fetchJobs, fetchCategory, category, fetchZones,
    setSelectedOrganizer, clearSelectedOrganizers, clearSearchCondition, searchData, clearUpdateFavorite, updateFavoriteSuccess,
    viewMode, setViewMode,
    getCompaniesByEvent, clearCompanyList,
    companyList, pageCompanyList, pageProductList,

    productsSmallBooth, productsStandardBooth, productsBigBooth, productsGrandBooth,
    successGetProductBigBooth, successGetProductSmallBooth, successGetProductStandardBooth, successGetProductGrandBooth,
    errorsGetProductBigBooth, errorsGetProductSmallBooth, errorsGetProductStandardBooth, errorsGetProductGrandBooth,
    getEventProductsBigZone, getEventProductsSmallZone, getEventProductsStandardZone, getEventProductsGrandZone,
    clearEventProductsBigZone, clearEventProductsSmallZone, clearEventProductsStandardZone, clearEventProductsGrandZone,
    isWeakAuth, isCheckEvent, customText, getCustomText, clearCustomText, locale,
     /*  ★★ */
    customTimerctrl,  getSettingCustomTimerctrl, clearCustomTimerctrl,
                
}) => {
    const localLang = sessionStorage.getItem('valueLang') || 'ja';
    const classes = useStyles(eventInfo);
    const intl = useIntl();
    const { shortName } = useParams();
    const history = useHistory();
    const [selectedOrganizers, setSelectedOrganizers] = useState({});
    const [allCheckedProducts, setAllCheckedProducts] = useState(false);
    const [allCheckedSmallBooth, setAllCheckedSmallBooth] = useState(false);
    const [allCheckedStandardBooth, setAllCheckedStandardBooth] = useState(false);
    const [allCheckedBigBooth, setAllCheckedBigBooth] = useState(false);
    const [allCheckedGrandBooth, setAllCheckedGrandBooth] = useState(false);
    const [errorDialog, setErrorDialog] = useState({ isOpen: false, message: '' });
    const [isChangeMode, setIsChangeMode] = useState(true);
    const [isCallApi, setIsCallApi] = useState(false);
    const [categoryState, setCategoryState] = useState({});
    const [choseCategoryState, setChoseCategoryState] = useState(null);

    // カテゴリごとに企業をグループ化する
    const groupedCompanies = {};

    function parseSearchDataToQueryString() {
        const queryObject = {};
        let queryString = '';

        if (searchData?.company) {
            queryObject.company_name = searchData.company;
        }
        if (searchData?.company) {
            queryObject.product = searchData.product_name;
        }
        if (searchData?.type) {
            queryObject.company_type = searchData.type;
        }
        if (searchData?.zone_id) {
            queryObject.zone_id = searchData.zone_id;
        }
        queryObject.explore_all = !viewMode;

        queryString = Object.keys(queryObject).map((key) => `${key}=${queryObject[key]}`).join('&');

        return queryString ? `?${queryString}` : '';
    }
    useEffect(() => {
        getCustomText({
            eventShortName: shortName,
            site: 0,
            text_type: 2,
            language: locale,
        });
        setIsCallApi(false);
        return () => {
            clearCustomText();
        };
    }, [locale]);

    useEffect(() => {
        if (localLang === locale) {
            fetchJobs({ shortName, language: locale });
            fetchCategory({shortName, language: locale});
            fetchZones({ shortName, language: locale });
            console.log("L721, shortName is ..." );
            console.log( shortName );
            
            if( shortName && (shortName=="test001" || shortName=="JPL24" ) ){
                getCompaniesByEvent(shortName,  {"page_size":99999},  locale);
            //    getCompaniesByEvent(shortName,  {},  locale);
            }else{
                getCompaniesByEvent(shortName,  {},  locale);
            }
        }
        return () => {
            clearSelectedOrganizers();
            clearSearchCondition();
            clearFavoriteCompanies();
            clearCompanyList();
        };
    }, [
        clearCompanyList, clearFavoriteCompanies, locale, 
        clearSearchCondition, clearSelectedOrganizers, 
        fetchJobs, fetchCategory, fetchZones, getCompaniesByEvent, shortName,
    ]);

    
    useEffect(() => {
        if (!_.isEmpty(category)) {
             setCategoryState(_.reduce(category, (result, value) => ({ ...result, [value]: value }), { }));
         }
     }, [category]);
     useEffect(() => {
        if (!_.isEmpty(category)) {
             setChoseCategoryState( category );
         }
     }, [category]);


    useEffect(() => {
        if (!_.isEmpty(companyList) && companyList?.length > 0 && isChangeMode) {
            setIsChangeMode(false);
            setViewMode(companyList.length > 9 ? VIEW_MODE.TABLE : VIEW_MODE.ICON_LIST);
        }
    }, [companyList]);

    /**
     * HOOKS
     */

    // Get favorite companies
    useEffect(() => {
        // if (eventInfo.sdate && isAuthorized && !eventInfo.free_login) {
        if (eventInfo.sdate && isAuthorized && isWeakAuth === '') {
            const startDateDifference = getDifferenceInDays(null, eventInfo.sdate);
            if (startDateDifference <= EVENT_EFFECT_DURATION.BEFORE) getFavoriteCompanies(locale);
        }
    }, [eventInfo, isAuthorized, getFavoriteCompanies, clearFavoriteCompanies]);

    // Get products
    useEffect(() => {
        if (eventInfo.sdate) {
            const startDateDifference = getDifferenceInDays(null, eventInfo.sdate);
            if (startDateDifference <= EVENT_EFFECT_DURATION.BEFORE && !isCallApi) {
                setIsCallApi(true);
                if ( eventInfo?.category?.length > 1){
                   //console.log("LINE781 exec");
                   //console.log( eventInfo);    
  //                 clearCompanyList();
//                   getCompaniesByEvent(shortName,  {"page_size":100000},  locale); 
                   
                   getEventProducts(shortName, {"page_size":100000}, locale);
                }else{
                    if (!eventInfo.layout_exhibition) {
                        if (eventInfo.has_zone) {
                            console.log("LINE779 exec");    
                            getEventProducts(shortName, {}, locale);
                        } else {
                            if (eventInfo.big_zone) getEventProductsBigZone(shortName, {}, locale);
                            if (eventInfo.small_zone) getEventProductsSmallZone(shortName, {}, locale);
                            if (eventInfo.standard_zone) getEventProductsStandardZone(shortName, {}, locale);
                            if (eventInfo.grand_zone) getEventProductsGrandZone(shortName, {}, locale);

                            console.log("LINE787 exec");    
                            // console.log( eventInfo );
                            getEventProducts(shortName, {}, locale);

                        }
                    } else {
                        console.log("LINE792 exec");    
                        getEventProducts(shortName, {}, locale);
                    }
                }
            }
        }

        return () => {
            clearEventProducts();
            clearEventProductsBigZone();
            clearEventProductsSmallZone();
            clearEventProductsStandardZone();
            clearEventProductsGrandZone();
        };
    }, [
        shortName, isAuthorized, eventInfo,
        getEventProducts, clearEventProducts,
        getEventProductsBigZone, getEventProductsSmallZone, getEventProductsStandardZone, getEventProductsGrandZone,
        clearEventProductsBigZone, clearEventProductsSmallZone, clearEventProductsStandardZone, clearEventProductsGrandZone,
    ]);

    // Save selected company IDs to checkbox states
    useEffect(() => {
        if (eventInfo.sdate) {
            const startDateDifference = getDifferenceInDays(null, eventInfo.sdate);
            if (startDateDifference <= EVENT_EFFECT_DURATION.BEFORE) {
                if (isAuthorized) {
                    if (companyIDs.length) {
                        const selected = {};
                        companyIDs.forEach((id) => { selected[id] = true; });
                        setSelectedOrganizers(selected);
                    }
                }
            }
        }
    }, [companyIDs, eventInfo, isAuthorized]);

    // Update "Check All" table header whenever display data or a checkbox status change
    useEffect(() => {
        const isAllDisplayedChecked = (selectedIDs, displayedIDs) => {
            if (!displayedIDs.length) return false;
            const selectedIDArray = getSelectedOrganizersAsArray(selectedIDs);
            const displayedIDArray = displayedIDs.map((product) => product.companyID && product.companyID.toString());
            return !_.difference(displayedIDArray, selectedIDArray).length;
        };

        if (eventInfo.has_zone) {
            setAllCheckedProducts(isAllDisplayedChecked(selectedOrganizers, allProducts.results));
        } else {
            setAllCheckedSmallBooth(isAllDisplayedChecked(selectedOrganizers, productsSmallBooth.results));
            setAllCheckedStandardBooth(isAllDisplayedChecked(selectedOrganizers, productsStandardBooth.results));
            setAllCheckedBigBooth(isAllDisplayedChecked(selectedOrganizers, productsBigBooth.results));
            setAllCheckedGrandBooth(isAllDisplayedChecked(selectedOrganizers, productsGrandBooth.results));
        }
    }, [
        eventInfo,  allProducts.results, selectedOrganizers,
        productsBigBooth.results, productsSmallBooth.results, productsStandardBooth.results, productsGrandBooth.results,
    ]);
    /* 上記、allProducts4Cate.results,を入れなかった。まだわからんので。 ★★*/

    // Display error dialog when getting all products
    useEffect(() => {
        if (successGetProducts === false) {
            setErrorDialog({
                isOpen: true,
                message: errorsGetProducts.message.message,
            });
        }
    }, [successGetProducts, errorsGetProducts]);

    // Display error dialog when getting small booth products
    useEffect(() => {
        if (successGetProductSmallBooth === false) {
            setErrorDialog({
                isOpen: true,
                message: errorsGetProductSmallBooth.message.message,
            });
        }
    }, [successGetProductSmallBooth, errorsGetProductSmallBooth]);

    // Display error dialog when getting big booth products
    useEffect(() => {
        if (successGetProductBigBooth === false) {
            setErrorDialog({
                isOpen: true,
                message: errorsGetProductBigBooth.message.message,
            });
        }
    }, [successGetProductBigBooth, errorsGetProductBigBooth]);

    // Display error dialog when getting standard booth products
    useEffect(() => {
        if (successGetProductStandardBooth === false) {
            setErrorDialog({
                isOpen: true,
                message: errorsGetProductStandardBooth.message.message,
            });
        }
    }, [successGetProductStandardBooth, errorsGetProductStandardBooth]);

    // Display error dialog when getting grand booth products
    useEffect(() => {
        if (successGetProductGrandBooth === false) {
            setErrorDialog({
                isOpen: true,
                message: errorsGetProductGrandBooth.message.message,
            });
        }
    }, [successGetProductGrandBooth, errorsGetProductGrandBooth]);

    useEffect(() => {
        if (updateFavoriteSuccess) {
            clearUpdateFavorite();
            clearFavoriteCompanies();
        }
    }, [updateFavoriteSuccess, clearFavoriteCompanies, clearUpdateFavorite]);

    /*  ★★ */
     // control timer 
    useEffect(() =>{
    	getSettingCustomTimerctrl({eventShortName: shortName});
    	return () =>{
    		clearCustomTimerctrl();
    	}
    },[shortName] );
      
    useEffect(() =>{
        //console.log("LINE868... choseCategoryState is..." );
        //console.log( choseCategoryState );
        //console.log("LINE870... searchData is..." );
        //console.log( searchData );
        //console.log("LINE872... category is..." );
        //console.log( category );
        //console.log("LINE874   END" );
        if( searchData.category){
            if( searchData.category=="allXXXCategory"){
                setChoseCategoryState( [] );
                setChoseCategoryState( category );

            }else if( searchData.category !== choseCategoryState){
                let renew_cateObj =[];
                renew_cateObj.push( searchData.category );
                setChoseCategoryState( renew_cateObj );

            }

        }else{
            if( searchData.category==""){
                setChoseCategoryState( category );
            }

        }

    }, [searchData.category]);


    /**
     * EVENT HANDLERS
     */

    const handleChangeAllCheckboxes = (checked, boothType = null) => {
        let setAllCheckFunc;
        let productArray;

        switch (boothType) {
            case BOOTH_TYPE.SMALL:
                setAllCheckFunc = setAllCheckedSmallBooth;
                productArray = productsSmallBooth.results;
                break;
            case BOOTH_TYPE.STANDARD:
                setAllCheckFunc = setAllCheckedStandardBooth;
                productArray = productsStandardBooth.results;
                break;
            case BOOTH_TYPE.BIG:
                setAllCheckFunc = setAllCheckedBigBooth;
                productArray = productsBigBooth.results;
                break;
            case BOOTH_TYPE.GRAND:
                setAllCheckFunc = setAllCheckedGrandBooth;
                productArray = productsGrandBooth.results;
                break;
            default:
                setAllCheckFunc = setAllCheckedProducts;
                productArray = allProducts.results;
                /*  ここにもallProducts4Cate.results,　を条件で入れるべきかも★★ */
                return;
        }
        setAllCheckFunc(checked);

        if (productArray && productArray.length) {
            const selected = { ...selectedOrganizers };
            productArray.forEach((product) => { selected[product.companyID] = checked; });
            setSelectedOrganizers(selected);
            if (isAuthorized) updateFavoriteCompanies(getSelectedOrganizersAsArray(selected), locale);
            setSelectedOrganizer(selected); // dispatch action set data to store
        }
    };

    const handleSetSelectedOrganizers = (id, value) => {
        const newSelectedOrganizers = { ...selectedOrganizers, [id]: value };
        setSelectedOrganizers(newSelectedOrganizers); // HERE
        const selected = getSelectedOrganizersAsArray(newSelectedOrganizers);
        if (isAuthorized) updateFavoriteCompanies(selected, locale);
        setSelectedOrganizer(newSelectedOrganizers); // dispatch action set data to store
    };

    const handleBrowse = () => {
        history.push(`/${shortName}/exhibitor-posters`);
    };

    const handleCloseErrorDialog = () => setErrorDialog((dialogState) => ({ ...dialogState, isOpen: false }));

    const handleChangePage = (page, booth = null) => {
        switch (booth) {
            case BOOTH_TYPE.SMALL:
                getEventProductsSmallZone(shortName, { ...searchData, page }, locale);
                break;
            case BOOTH_TYPE.STANDARD:
                getEventProductsStandardZone(shortName, { ...searchData, page }, locale);
                break;
            case BOOTH_TYPE.BIG:
                getEventProductsBigZone(shortName, { ...searchData, page }, locale);
                break;
            case BOOTH_TYPE.GRAND:
                getEventProductsGrandZone(shortName, { ...searchData, page }, locale);
                break;
            default:
                getEventProducts(shortName, { ...searchData, page }, locale);
        }
    };

    const getSelectedOrganizersAsArray = (value) => {
        const selected = Object.keys(value).reduce((acc, key) => {
            if (value[key]) acc.push(key);
            return acc;
        }, []);
        return selected;
    };

    const getDifferenceInDays = (start, end) => {
        const startDate = start ? new Date(start) : new Date();
        startDate.setHours(0, 0, 0, 0);
        const endDate = end ? new Date(end) : new Date();
        endDate.setHours(0, 0, 0, 0);
        return (endDate - startDate) / 86400000;
    };

    const handleProductViewRouting = (company_id) => {
        //  history.push(`/${shortName}/${company_id}/products${parseSearchDataToQueryString()}`);
        const url = `/oes/${shortName}/${company_id}/products${parseSearchDataToQueryString()}`;
        window.open(url, '_blank');
    };

    const handleRedirectDetail = useCallback((id) => {
        if (!isAuthorized || (!eventInfo.free_exhibition && (isWeakAuth || isWeakAuth === 'true'))) {
            return;
        }

        handleProductViewRouting(id);
    }, [eventInfo, isAuthorized, shortName, history, viewMode]);

    const handleRedirectRegisterSeminar = () => {
        history.push(`/${shortName}/register-visitor`);
    };

    const formatData = (product, i, arr) => {
        const isFromSameCompanyAsAbove = i !== 0 && product.companyID === arr[i - 1].companyID;
        const dataResult = eventInfo.has_zone ? [
            isFromSameCompanyAsAbove
                ? null
                : (
                    <div style={{ display: 'flex', justifyContent: 'center' }}>
                        {(isAuthorized && !eventInfo.free_exhibition && isWeakAuth === '') && (
                            <Checkbox
                                color="primary"
                                style={{ color: eventInfo?.settings_colors_viewer?.button_background_color?.common_button || navyColor }}
                                checked={!!selectedOrganizers[product.companyID]}
                                onChange={(e) => handleSetSelectedOrganizers(product.companyID, e.target.checked)}
                            />
                        )}
                        {(isAuthorized) && (
                            <Button
                                color="navy"
                                onClick={() => handleProductViewRouting(product.companyID)}
                                round
                                size="md"
                                buttonTextColor={eventInfo?.settings_colors_viewer?.button_text_color}
                                buttonBackgroundColor={eventInfo?.settings_colors_viewer?.button_background_color?.common_button}
                            >
                                {customText?.button_name?.direct_selection || intl.formatMessage({ id: 'directToDetailProduct' })}
                            </Button>
                        )}

                    </div>
                ),
            isFromSameCompanyAsAbove ? null : product.companyName,
            isFromSameCompanyAsAbove ? null : product.zoneName,
            isFromSameCompanyAsAbove ? null : product.companyType,
            product.name,
            renderMediaType(product.mediaType, product.mediaDuration),
            product.companyID,
        ] : [
            isFromSameCompanyAsAbove
                ? null
                : (
                    <div style={{ display: 'flex', justifyContent: 'center' }}>
                        {/* {(isAuthorized && !eventInfo.free_login) && ( */}
                        {(isAuthorized && !eventInfo.free_exhibition && isWeakAuth === '') && (
                            <Checkbox
                                color="primary"
                                style={{ color: eventInfo?.settings_colors_viewer?.button_background_color?.common_button || navyColor }}
                                checked={!!selectedOrganizers[product.companyID]}
                                onChange={(e) => handleSetSelectedOrganizers(product.companyID, e.target.checked)}
                            />
                        )}

                        {(isAuthorized) && (
                            <Button
                                color="navy"
                                onClick={() => handleProductViewRouting(product.companyID)}
                                round
                                size="md"
                                buttonTextColor={eventInfo?.settings_colors_viewer?.button_text_color}
                                buttonBackgroundColor={eventInfo?.settings_colors_viewer?.button_background_color?.common_button}
                            >
                                {customText?.button_name?.direct_selection || intl.formatMessage({ id: 'directToDetailProduct' })}
                            </Button>
                        )}
                    </div>
                ),
            isFromSameCompanyAsAbove ? null : product.companyName,
            isFromSameCompanyAsAbove ? null : product.companyType,
            product.name,
            renderMediaType(product.mediaType, product.mediaDuration),
            product.companyID,
        ];

        if (    
              isAfterUsingEndXdays(
            	  eventInfo.edate,
            	  (customTimerctrl && customTimerctrl.hasOwnProperty("TC_exhprod_after") ) ? customTimerctrl.TC_exhprod_after : 30 
                 )
            || !isAuthorized
            || (!eventInfo.free_exhibition && (isWeakAuth || isWeakAuth === 'true'))
            ) {
            dataResult.shift();
        }
        return dataResult;
    };

    const isSearchButtonDisabled = () => {
        if (!getSelectedOrganizersAsArray(selectedOrganizers).length) return true;
//        if (!isBeforeStart14Day(eventInfo.sdate) && !isAfterEnd30Day(eventInfo.edate)) return false;
/*  ★★  */
        if ( ! isBeforeUsingStartXdays( 
               eventInfo.sdate, 
               (customTimerctrl && customTimerctrl.hasOwnProperty("TC_exhlist_before") ) ? customTimerctrl.TC_exhlist_before : 14 
                )
               &&
            ! isAfterUsingEndXdays(
            	  eventInfo.edate,
            	  (customTimerctrl && customTimerctrl.hasOwnProperty("TC_exhprod_after") ) ? customTimerctrl.TC_exhprod_after : 30 
                 ) 
          ){
		   return false;
          }

        return true;
    };

    /**
     * RENDER FUNCTIONS
     */

    const renderMediaType = (type, duration) => (
        <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center" flexWrap="wrap">
            {type === MEDIA_TYPE.IMAGE && <Image color="black" />}
            {type === MEDIA_TYPE.AUDIO && <HeadsetIcon color="black" />}
            {type === MEDIA_TYPE.VIDEO && <VideoCam color="black" />}
            {(type === MEDIA_TYPE.AUDIO || type === MEDIA_TYPE.VIDEO)
            && (
                <p>
                    {convertDuration(
                        duration,
                        intl.formatMessage({ id: 'common.hour' }),
                        intl.formatMessage({ id: 'common.minute' }),
                        intl.formatMessage({ id: 'common.second' }),
                    )}
                </p>
            )}
        </Box>
    );

    const renderTable = (booth = null) => {
        let boothTitle;
        let listData;
        let listDataGroup;
        let tableHead;
        let currentPage;
        let totalPage;
        let tableHeadWidth;
        let commonTableHeadColumns;

        if ((
              isAfterUsingEndXdays(
            	  eventInfo.edate,
            	  (customTimerctrl && customTimerctrl.hasOwnProperty("TC_exhprod_after") ) ? customTimerctrl.TC_exhprod_after : 30 
                 )                
            || !(isAuthorized && !eventInfo.free_exhibition && isWeakAuth === '')
               )
            && !eventInfo.has_zone) {
            tableHeadWidth = ['17.5%', '23.5%', '18%', '29%', '12%'];
            commonTableHeadColumns = [
                customText?.field_name?.exhibitor_participants || intl.formatMessage({ id: 'organizeCompany' }),
                customText?.field_name?.industry || intl.formatMessage({ id: 'industryType' }),
                customText?.field_name?.product_name || intl.formatMessage({ id: 'productRegister.productName' }),
                customText?.field_name?.product_image_movement_sound || intl.formatMessage({ id: 'organizerList.productImageVideoAudio' }),
            ];
        } else if (eventInfo.has_zone) {
            tableHeadWidth = ['17.5%', '19%', '14.5%', '14.5%', '24%', '10%'];

            commonTableHeadColumns = [
                customText?.field_name?.exhibitor_participants || intl.formatMessage({ id: 'organizeCompany' }),
                customText?.field_name?.zone || intl.formatMessage({ id: 'zone' }),
                customText?.field_name?.industry || intl.formatMessage({ id: 'industryType' }),
                customText?.field_name?.product_name || intl.formatMessage({ id: 'productRegister.productName' }),
                customText?.field_name?.product_image_movement_sound || intl.formatMessage({ id: 'organizerList.productImageVideoAudio' }),
            ];
        } else {
            tableHeadWidth = ['17.5%', '23.5%', '18%', '29%', '12%'];
            commonTableHeadColumns = [
                customText?.field_name?.exhibitor_participants || intl.formatMessage({ id: 'organizeCompany' }),
                customText?.field_name?.industry || intl.formatMessage({ id: 'industryType' }),
                customText?.field_name?.product_name || intl.formatMessage({ id: 'productRegister.productName' }),
                customText?.field_name?.product_image_movement_sound || intl.formatMessage({ id: 'organizerList.productImageVideoAudio' }),
            ];
        }

        const groupCompany = (lst) => _.reduce(lst, (rs, value) => {
            if (rs[value.companyID]) {
                return {
                    ...rs,
                    [value.companyID]: [...rs[value.companyID], value.companyID],
                };
            }
            return { ...rs, [value.companyID]: [`${value.companyID}`] };
        }, {});

        switch (booth) {
            case BOOTH_TYPE.SMALL:
                boothTitle    = _.get(eventInfo, 'setting_booth.small_zone.name');
                listData      = productsSmallBooth.results.map(formatData);
                listDataGroup = groupCompany(productsSmallBooth.results);

    
                tableHead = [(
                    <>
                        {(isAuthorized && !eventInfo.free_exhibition && isWeakAuth === '') && (
                            <Checkbox
                                classes={{ root: classes.checkboxHeader, checked: classes.checkboxHeaderChecked }}
                                checked={allCheckedSmallBooth}
                                onChange={(e) => handleChangeAllCheckboxes(e.target.checked, BOOTH_TYPE.SMALL)}
                                style={{ color: eventInfo?.settings_colors_viewer?.list_table?.title_text_color }}
                            />
                        )}
                        {customText?.field_name?.browsing_company_check
                            ? `${customText?.field_name?.browsing_company_check}` : intl.formatMessage({ id: 'exhibition.browsingCompany' })}
                    </>
                ), ...commonTableHeadColumns];
                currentPage = productsSmallBooth.page;
                totalPage = productsSmallBooth.totalPage;
                break;
            case BOOTH_TYPE.STANDARD:
                boothTitle = _.get(eventInfo, 'setting_booth.standard_zone.name');
                listData = productsStandardBooth.results.map(formatData);
                listDataGroup = groupCompany(productsStandardBooth.results);

                tableHead = [(
                    <>
                        {(isAuthorized && !eventInfo.free_exhibition && isWeakAuth === '') && (
                            <Checkbox
                                classes={{ root: classes.checkboxHeader, checked: classes.checkboxHeaderChecked }}
                                checked={allCheckedStandardBooth}
                                onChange={(e) => handleChangeAllCheckboxes(e.target.checked, BOOTH_TYPE.STANDARD)}
                                style={{ color: eventInfo?.settings_colors_viewer?.list_table?.title_text_color }}
                            />
                        )}
                        {customText?.field_name?.browsing_company_check
                            ? `${customText?.field_name?.browsing_company_check}` : intl.formatMessage({ id: 'exhibition.browsingCompany' })}
                    </>
                ), ...commonTableHeadColumns];
                currentPage = productsStandardBooth.page;
                totalPage = productsStandardBooth.totalPage;
                break;
            case BOOTH_TYPE.BIG:
                boothTitle = _.get(eventInfo, 'setting_booth.big_zone.name');
                listData = productsBigBooth.results.map(formatData);
                listDataGroup = groupCompany(productsBigBooth.results);
                tableHead = [(
                    <>
                        {(isAuthorized && !eventInfo.free_exhibition && isWeakAuth === '') && (
                            <Checkbox
                                classes={{ root: classes.checkboxHeader, checked: classes.checkboxHeaderChecked }}
                                checked={allCheckedBigBooth}
                                onChange={(e) => handleChangeAllCheckboxes(e.target.checked, BOOTH_TYPE.BIG)}
                                style={{ color: eventInfo?.settings_colors_viewer?.list_table?.title_text_color }}
                            />
                        )}
                        {customText?.field_name?.browsing_company_check
                            ? `${customText?.field_name?.browsing_company_check}` : intl.formatMessage({ id: 'exhibition.browsingCompany' })}
                    </>
                ), ...commonTableHeadColumns];
                currentPage = productsBigBooth.page;
                totalPage = productsBigBooth.totalPage;
                break;
            case BOOTH_TYPE.GRAND:
                boothTitle = _.get(eventInfo, 'setting_booth.grand_zone.name');
                listData = productsGrandBooth.results.map(formatData);
                listDataGroup = groupCompany(productsGrandBooth.results);
                tableHead = [(
                    <>
                        {(isAuthorized && !eventInfo.free_exhibition && isWeakAuth === '') && (
                            <Checkbox
                                classes={{ root: classes.checkboxHeader, checked: classes.checkboxHeaderChecked }}
                                checked={allCheckedGrandBooth}
                                onChange={(e) => handleChangeAllCheckboxes(e.target.checked, BOOTH_TYPE.GRAND)}
                                style={{ color: eventInfo?.settings_colors_viewer?.list_table?.title_text_color }}
                            />
                        )}
                        {customText?.field_name?.browsing_company_check
                            ? `${customText?.field_name?.browsing_company_check}` : intl.formatMessage({ id: 'exhibition.browsingCompany' })}
                    </>
                ), ...commonTableHeadColumns];
                currentPage = productsGrandBooth.page;
                totalPage = productsGrandBooth.totalPage;
                break;
            case null:
                listData = allProducts.results.map(formatData);
                listDataGroup = groupCompany(allProducts.results);

                tableHead = [(
                    <>
                        {(isAuthorized && !eventInfo.free_exhibition && isWeakAuth === '') && (
                            <Checkbox
                                classes={{ root: classes.checkboxHeader, checked: classes.checkboxHeaderChecked }}
                                checked={allCheckedProducts}
                                onChange={(e) => handleChangeAllCheckboxes(e.target.checked)}
                                style={{ color: eventInfo?.settings_colors_viewer?.list_table?.title_text_color }}
                            />
                        )}
                        {customText?.field_name?.browsing_company_check
                            ? `${customText?.field_name?.browsing_company_check}` : intl.formatMessage({ id: 'exhibition.browsingCompany' })}
                    </>
                ), ...commonTableHeadColumns];
                currentPage = allProducts.page;
                totalPage = allProducts.totalPage;
                break;
            default:
                boothTitle = null;
                listData = [];
                tableHead = [];
                listDataGroup = {};
                break;
        }

        if(    isAfterUsingEndXdays(
            	   eventInfo.edate,
            	   (customTimerctrl && customTimerctrl.hasOwnProperty("TC_exhprod_after") ) ? customTimerctrl.TC_exhprod_after : 30 
                   )
        	  || !isAuthorized 
        	  || (isAuthorized && (isWeakAuth || isWeakAuth === 'true') && !eventInfo.free_exhibition)
        	) {
            tableHead.shift();

            tableHeadWidth = eventInfo.has_zone
                ? ['20%', '15%', '15%', '25%', '10%']
                : ['29%', '21%', '36%', '14%'];
        }

        return (
            <>
                {!eventInfo.has_zone && (
                    <Typography variant="h6" className={classes.zoneTitle} customColor={eventInfo?.settings_colors_viewer?.contents_text_color}>
                        {boothTitle}
                    </Typography>
                )}

                <Box display="flex" justifyContent="center">
                    <Pagination
                        page={currentPage}
                        total={totalPage}
                        onChange={(page) => handleChangePage(page, booth)}
                        color="secondary"
                        colorBackgroundCustom={eventInfo?.settings_colors_viewer?.list_table?.odd_record_background_color}
                        colorTextCustom={eventInfo?.settings_colors_viewer?.button_background_color?.common_button}
                    />
                </Box>

                <Table
                    cellColor={eventInfo?.settings_colors_viewer?.list_table?.title_background_color || navyColor}
                    cellTextColorHear={eventInfo?.settings_colors_viewer?.list_table?.title_text_color}
                    cellTextColorBody={eventInfo?.settings_colors_viewer?.contents_text_color}
                    cellBackgroundColor={eventInfo?.settings_colors_viewer?.list_table}
                    tableHead={tableHead}
                    tableHeadWidth={tableHeadWidth}
                    tableData={listData}
                    variantHeader="subtitle1"
                    groupRowColor={listDataGroup}
                    tableFooter={(
                        <Box display="flex" justifyContent="center">
                            <Pagination
                                page={currentPage}
                                total={totalPage}
                                onChange={(page) => handleChangePage(page, booth)}
                                color="secondary"
                                colorBackgroundCustom={eventInfo?.settings_colors_viewer?.list_table?.odd_record_background_color}
                                colorTextCustom={eventInfo?.settings_colors_viewer?.button_background_color?.common_button}
                            />
                        </Box>
                    )}
                    noDataMessage={(
                        <GridItem
                            xs={12}
                            style={{
                                textAlign: 'center',
                                fontWeight: 'bold',
                                fontSize: '20px',
                                zIndex: 1,
                            }}
                        >
                            <FormattedMessage id="productManagement.noData" />
                        </GridItem>
                    )}
                />
            </>
        );
    };

    const renderIconList = () => (
        <GridContainer className={classes.container}>
            {companyList.map((item) => (
                <GridItem
                    md={3}
                    className={classes.items}
                    key={item.id}
                    onClick={() => handleRedirectDetail(item.id)}
                    style={{ cursor: isAuthorized ? 'pointer' : 'auto' }}
                >
                    <img src={item.image ? item.image : '/resources/No_image_found.jpg'} alt={item.short_name} />
                    <p>{item.full_name}</p>
                </GridItem>
            ))}
        </GridContainer>
    );

    const renderList = () => (
        <>
            {viewMode === VIEW_MODE.ICON_LIST && renderIconList()}
            {(viewMode === VIEW_MODE.TABLE && eventInfo.has_zone) && renderTable()}
            {(viewMode === VIEW_MODE.TABLE && !eventInfo.has_zone && eventInfo.small_zone) && renderTable(BOOTH_TYPE.SMALL)}
            {(viewMode === VIEW_MODE.TABLE && !eventInfo.has_zone && eventInfo.standard_zone) && renderTable(BOOTH_TYPE.STANDARD)}
            {(viewMode === VIEW_MODE.TABLE && !eventInfo.has_zone && eventInfo.big_zone) && renderTable(BOOTH_TYPE.BIG)}
            {(viewMode === VIEW_MODE.TABLE && !eventInfo.has_zone && eventInfo.grand_zone) && renderTable(BOOTH_TYPE.GRAND)}
            {(isAuthorized && (!isWeakAuth || isWeakAuth === '')) && (
                <Box textAlign="center" mt={3} mb={2}>
                    <Button
                        color="navy"
                        onClick={handleBrowse}
                        disabled={isSearchButtonDisabled()}
                        round
                        size="md"
                        className={classes.buttonBig}
                        buttonTextColor={eventInfo?.settings_colors_viewer?.button_text_color}
                        buttonBackgroundColor={eventInfo?.settings_colors_viewer?.button_background_color?.common_button}
                    >
                        {customText?.button_name?.lis_companies_want_see || intl.formatMessage({ id: 'browse.listOfCompany' })}
                    </Button>
                </Box>
            )}
        </>
    );


    const renderMain = () => {
        if (!eventInfo.sdate || !eventInfo.edate) return null;
        const startDateDifference = getDifferenceInDays(null, eventInfo.sdate);

        let messageID;
/*
        if (startDateDifference > EVENT_EFFECT_DURATION.BEFORE) {
            messageID = 'organizerList.14DaysBefore';
        }
        */
        let convMsgVal=0; //default 14days ,but here setting 0
        /* 
        if( isBeforeUsingStartXdays( 
               eventInfo.sdate, 
               ( customTimerctrl && customTimerctrl.hasOwnProperty("TC_exhlist_before") && customTimerctrl.TC_exhlist_before ) 
                ? customTimerctrl.TC_exhlist_before 
                   : 14 
                )
           ){
           messageID = 'organizerList.XDaysBefore';
             if( customTimerctrl && customTimerctrl.hasOwnProperty("TC_exhlist_before") && customTimerctrl.TC_exhlist_before ){
             		convMsgVal =customTimerctrl.TC_exhlist_before;
             	}else{
             	   convMsgVal = 14
             	}

          }

        if( isAfterUsingEndXdays( 
               eventInfo.edate, 
               ( customTimerctrl && customTimerctrl.hasOwnProperty("TC_exhprod_after") && customTimerctrl.TC_exhprod_after ) 
                ? customTimerctrl.TC_exhprod_after 
                   : 30 
                )
           ){
           messageID = 'organizerList.XDaysAfter';
             if( customTimerctrl && customTimerctrl.hasOwnProperty("TC_exhprod_after") && customTimerctrl.TC_exhprod_after ){
             		convMsgVal =customTimerctrl.TC_exhprod_after;
             	}else{
             	   convMsgVal = 30
             	}
          }
        */

        if (messageID) {
            return (
                <Box textAlign="center">
                    <Typography variant="h5" customColor={eventInfo?.settings_colors_viewer?.contents_text_color}>
                       
                       { intl.formatMessage({ id: messageID},{XSDiffDAY: `${convMsgVal}`}) 	}
                        
                    </Typography>
                </Box>
            );
        }

        return (
            <>
                {!eventInfo.layout_exhibition
                    ? renderList()
                    : (
                        <OrganizerListCustomLayoutFirst
                            viewMode={viewMode}
                            companyList={companyList}
                            isAuthorized={isAuthorized}
                            handleRedirectDetail={(id) => handleRedirectDetail(id)}
                            eventInfo={eventInfo}
                            productsSmallBooth={productsSmallBooth}
                            productsStandardBooth={productsStandardBooth}
                            productsBigBooth={productsBigBooth}
                            productsGrandBooth={productsGrandBooth}
                            allProducts={allProducts}
                            customText={customText}
                            handleBrowse={() => handleBrowse()}
                            isSearchButtonDisabled={isSearchButtonDisabled()}
                            addFavorite={selectedOrganizers}
                            handleAddFavorite={(companyId, value) => handleSetSelectedOrganizers(companyId, value)}
                            customColor={eventInfo?.settings_colors_viewer}
                        />
                    )}
            </>
        );
    };

    const renderBottomButton = () => {
        if (!isAuthorized && isCheckEvent) {
            if (!eventInfo.free_exhibition && !eventInfo.outer_server_activation) {
                if (!eventInfo.free_seminar && !eventInfo.free_live_stream) return <RegisterLinks />;
                return (
                    <GridItem container item className={classes.sectionWrapper}>
                        <GridItem xs={12} lg={6}>
                            <div className={classes.centerToRight}>
                                <Button
                                    color="info"
                                    gradient
                                    className={classes.buttonBig2}
                                    round
                                    onClick={handleRedirectRegisterSeminar}
                                    buttonTextColor={eventInfo?.settings_colors_viewer?.button_text_color}
                                    buttonBackgroundColor={eventInfo?.settings_colors_viewer?.button_background_color?.viewer}
                                >
                                    {intl.formatMessage({ id: 'exhibition.apply' })}
                                </Button>
                            </div>
                        </GridItem>
                        <GridItem xs={12} lg={6}>
                            <Box display="flex" className={classes.helperText}>
                                <RadioButtonIcon color={eventInfo?.settings_colors_viewer?.button_background_color?.viewer || '#4facfe'} />
                                <Typography variant="subtitle1" customColor={eventInfo?.settings_colors_viewer?.contents_text_color}>
                                    {intl.formatMessage({ id: 'exhibition.noteRegister' }, {
                                        exhibition: eventInfo.settings_texts_sidebar_viewer?.field_name?.exhibitor_info_list || intl.formatMessage({ id: 'home.exhibition' }),
                                    })}
                                </Typography>
                            </Box>
                        </GridItem>
                    </GridItem>
                );
            }
            return (eventInfo.free_exhibition) && <FreeLogin customColor={eventInfo?.settings_colors_viewer} />;
        }
        if (isAuthorized && isWeakAuth) {
            if (!eventInfo.free_exhibition && !eventInfo.outer_server_activation) {
                return (
                    <GridItem container item className={classes.sectionWrapper}>
                        <GridItem xs={12} lg={6}>
                            <div className={classes.centerToRight}>
                                <Button
                                    color="info"
                                    gradient
                                    className={classes.buttonBig2}
                                    round
                                    onClick={handleRedirectRegisterSeminar}
                                    buttonTextColor={eventInfo?.settings_colors_viewer?.button_text_color}
                                    buttonBackgroundColor={eventInfo?.settings_colors_viewer?.button_background_color?.viewer}
                                >
                                    {intl.formatMessage({ id: 'exhibition.apply' })}
                                </Button>
                            </div>
                        </GridItem>
                        <GridItem xs={12} lg={6}>
                            <Box display="flex" className={classes.helperText}>
                                <RadioButtonIcon color={eventInfo?.settings_colors_viewer?.button_background_color?.viewer || '#4facfe'} />
                                <Typography variant="subtitle1" customColor={eventInfo?.settings_colors_viewer?.contents_text_color}>
                                    {intl.formatMessage({ id: 'exhibition.noteRegister' }, {
                                        exhibition: eventInfo.settings_texts_sidebar_viewer?.field_name?.exhibitor_info_list || intl.formatMessage({ id: 'exhibited.products' }),
                                    })}
                                </Typography>
                            </Box>
                        </GridItem>
                    </GridItem>
                );
            }
        }
        return null;
    };

    const handleChange = (intersection) => {
        if (intersection) {
            if (!eventInfo.layout_exhibition) {
                if (+pageCompanyList.page < +pageCompanyList.total_page) {
                    getCompaniesByEvent(shortName, { ...searchData, page: +pageCompanyList.page + 1 }, locale);
                }
            } else if ((+pageProductList.page < +pageProductList.total_page) && viewMode) {
                getEventProducts(shortName, { ...searchData, page: +pageProductList.page + 1 }, locale);
            } else if ((+pageCompanyList.page < +pageCompanyList.total_page) && !viewMode) {
                getCompaniesByEvent(shortName, { ...searchData, page: +pageCompanyList.page + 1 }, locale);
            }
        }
    };
    const options = {
        threshold: 1,
        rootMargin: '0px',
        onChange: handleChange,
    };

    /*
    companyList.forEach((company) => {
        const { companyCategory, ...otherProps } = company;
        
        if (!groupedCompanies[companyCategory]) {
            groupedCompanies[companyCategory] = [];
        }
        
        groupedCompanies[companyCategory].push({
            companyCategory,
            ...otherProps,
        });
    });
    */
    const refreshBtnDisp = () => {
        if( searchData?.category  && searchData.category != "allXXXCategory"){
            return (
                <>

                    <Button
                                    round
                                    size="md"
                                    buttonBackgroundColor={eventInfo?.settings_colors_viewer?.button_background_color?.common_button}
                                    onClick={()=>window.location.reload()}
                                    buttonTextColor={eventInfo?.settings_colors_viewer?.button_text_color}
                                    style={{fontSize:"1.5em",marginBottom:"10px",float: 'right', backgroundColor:'rgb(254,47,96)',fontWeight:600}}
                                >
                                    {"全ての"+CateGetNameOfCategoryByFirstStr[category[0]]+'を表示する' }
                    </Button>
                </>
            );    
        }
    }

    const renderByCategory= (booth = null) =>{

         console.log("L-1680 searchData is...");
         console.log( searchData );

        if( companyList && companyList.length > 0 ){
            /*
            const groupCompaniesByCategory = (companyList) => _.reduce(companyList, (result, company) => {
                const { id, companyCategory, ...otherProps } = company;

                // 企業カテゴリごとのグループを取得
                const categoryGroup = result[companyCategory] || [];
                // カテゴリごとのグループに現在の企業を追加
                const updatedCategoryGroup = [...categoryGroup, { ...otherProps }];
                // 企業カテゴリごとのグループを更新
                return {
                    ...result,
                    [companyCategory]: updatedCategoryGroup,
                };
            }, {});
            */
            const groupCompaniesByCategory = (companyList) => {
                const result={};
                for(const company of companyList){
                    const { id, companyCategory, ...otherProps} = company;
                    const categoryGroup = result[companyCategory] || [];
                    const updatedCategoryGroup =[...categoryGroup, {...otherProps}];
                    result[companyCategory] = updatedCategoryGroup;
                }
                return result;
            };
            // 上記のグループ化関数を使って、カテゴリごとにグループ化された企業一覧を得る
            //console.log( "1527 companyList is " );
            //console.log( companyList );
            const groupedCompanies = groupCompaniesByCategory(companyList);
            if (groupedCompanies && Object.keys(groupedCompanies).length > 0 ) {
                // ここに処理を書く

                let boothTitle;
                let listData;
                let listDataGroup;
                let tableHead;
                let tableHeadWidth;
                let commonTableHeadColumns;
                if (isAuthorized && (!isWeakAuth || isWeakAuth === '')) {
                    tableHeadWidth = ['17.5%', '23.5%', '18%', '29%', '12%'];
                    commonTableHeadColumns = [
                            customText?.field_name?.exhibitor_participants || intl.formatMessage({ id: 'organizeCompany' }),
                            customText?.field_name?.industry || intl.formatMessage({ id: 'industryType' }),
                            customText?.field_name?.product_name || intl.formatMessage({ id: 'productRegister.productName' }),
                            customText?.field_name?.product_image_movement_sound || intl.formatMessage({ id: 'organizerList.productImageVideoAudio' }),
                    ];
                }else{
                    tableHeadWidth = ['17.5%', '23.5%', '18%', '29%', '12%'];
                    //tableHeadWidth = [ '30%', '26%', '30%', '14%'];
                    commonTableHeadColumns = [
                            customText?.field_name?.exhibitor_participants || intl.formatMessage({ id: 'organizeCompany' }),
                            customText?.field_name?.industry || intl.formatMessage({ id: 'industryType' }),
                            customText?.field_name?.product_name || intl.formatMessage({ id: 'productRegister.productName' }),
                            customText?.field_name?.product_image_movement_sound || intl.formatMessage({ id: 'organizerList.productImageVideoAudio' }),
                    ];
                }
                boothTitle = '';
                listData ={};
                let insideLocalprolist=allProducts4Cate.results;     // ここを allProductsからallProducts4Cateへ変更

                for(const key in groupedCompanies){
                    if(groupedCompanies.hasOwnProperty(key)){
                        const companies = groupedCompanies[key];
                        listData[key] =companies.reduce((acc, company )=> {
                            const thisPro=insideLocalprolist.find(thisPro => thisPro.userID === company.user);
                            if( thisPro ){
                                const companyIDs= acc.map( item  => item.userID) ;
                                if(companyIDs.includes(thisPro.userID)){
                                    acc.push(formatForCategoryData(thisPro,"NonFIRST") );
                                }else{
                                    acc.push( formatForCategoryData(thisPro,"") );
                                }
                            }
                            return acc;
                        },[]);

                        /*
                        for(const company of companies){
                            const dupeCheckHash = {};
                            for(let i=0; i<insideLocalprolist.length; i++){
                                const thisPro=insideLocalprolist[i];
                                if( thisPro.userID === company.user){
                                    if (dupeCheckHash.hasOwnProperty(thisPro.userID)) {
                                        listData[key].push(formatForCategoryData(thisPro,"NonFIRST"));
                                    }else{
                                        listData[key].push(formatForCategoryData(thisPro,""));
                                        dupeCheckHash[thisPro.userID] = 1;
                                    }
                                }
                            }
                        }
                        */
                    }
                }
                // console.log("1585 listData is...");
                // console.log( listData );

                tableHead = [(
                    <>
                        {customText?.field_name?.browsing_company_check
                            ? `${customText?.field_name?.browsing_company_check}` : intl.formatMessage({ id: 'exhibition.browsingCompany' })}
                    </>
                ), ...commonTableHeadColumns];
                if (! isAuthorized && eventInfo.free_exhibition) {
                    tableHead = [...commonTableHeadColumns];
                }
                /*
                if(searchData.category && ! renew_cateObj.length){
                    renew_cateObj.push( searchData.category );

                   setChoseCategoryState(  renew_cateObj ) ;
                   
                }
                */
                if( choseCategoryState?.length === 1 && ! groupedCompanies.hasOwnProperty( choseCategoryState[0] )  ){
                        return (<><div><strong style={{ fontSize: '2.0em' }}>{choseCategoryState[0]}</strong></div><div><strong style={{fontSize:'2.0em'}}>該当企業が見つかりませんでした。</strong></div></>);
                }
                return (
                    <>
                    {   !eventInfo.has_zone && (
                                <Typography variant="h6" className={classes.zoneTitle} customColor={eventInfo?.settings_colors_viewer?.contents_text_color}>
                                    {boothTitle}
                                </Typography>
                         )
                    }

                    {
                    choseCategoryState?.length === 0 ? (
                        <div>
                            <strong style={{ fontSize: '2.0em' }}>該当企業が見つかりません</strong>
                        </div>
                     ) : (
                        choseCategoryState?.map(key => (
                            groupedCompanies.hasOwnProperty( key ) && (
                                <div>
                                <strong style={{ fontSize: '2.0em' }}>{key}</strong>
                                {refreshBtnDisp()}
                                <Table
                                    cellColor={eventInfo?.settings_colors_viewer?.list_table?.title_background_color || navyColor}
                                    cellTextColorHear={eventInfo?.settings_colors_viewer?.list_table?.title_text_color}
                                    cellTextColorBody={eventInfo?.settings_colors_viewer?.contents_text_color}
                                    cellBackgroundColor={eventInfo?.settings_colors_viewer?.list_table}
                                    tableHead={tableHead}
                                    tableHeadWidth={tableHeadWidth}
                                    tableData={listData[key]  || null}
                                    variantHeader="subtitle1"
                                    groupRowColor={  1 }
                                    noDataMessage={(
                                        <GridItem
                                            xs={12}
                                            style={{
                                                textAlign: 'center',
                                                fontWeight: 'bold',
                                                fontSize: '20px',
                                                zIndex: 1,
                                            }}
                                        >
                                            <FormattedMessage id="productManagement.noData" />
                                        </GridItem>
                                    )}
                                />
                                </div>
                                )
                            )
                        )
                    )
                    }
                    </>
                );
                

            }
        }else{
            return (
                <>
                    <Typography variant="h6" className="" customColor={eventInfo?.settings_colors_viewer?.contents_text_color}>
                        {"Data Loading . . ."}
                    </Typography>
                </>
            );
        }
    };
    const formatForCategoryData = (product, FirstFLAG) => {
        //console.log("GGG,  gmmee" + " firstFlg is..." + FirstFLAG ) ;
        //console.log("product is....");
        //console.log( product);
        const isFromSameCompanyAsAbove = FirstFLAG;
        const dataResult = eventInfo.has_zone ? [
            isFromSameCompanyAsAbove
                ? null
                : (
                    <div style={{ display: 'flex', justifyContent: 'center' }}>
                        {(isAuthorized && !eventInfo.free_exhibition && isWeakAuth === '') && (
                            <Checkbox
                                color="primary"
                                style={{ color: eventInfo?.settings_colors_viewer?.button_background_color?.common_button || navyColor }}
                                checked={!!selectedOrganizers[product.companyID]}
                                onChange={(e) => handleSetSelectedOrganizers(product.companyID, e.target.checked)}
                            />
                        )}
                        {(isAuthorized) && (
                            <Button
                                color="navy"
                                onClick={() => handleProductViewRouting(product.companyID)}
                                round
                                size="md"
                                buttonTextColor={eventInfo?.settings_colors_viewer?.button_text_color}
                                buttonBackgroundColor={eventInfo?.settings_colors_viewer?.button_background_color?.common_button}
                            >
                                {customText?.button_name?.direct_selection || intl.formatMessage({ id: 'directToDetailProduct' })}
                            </Button>
                        )}

                    </div>
                ),
            isFromSameCompanyAsAbove ? null : product.companyName,
            isFromSameCompanyAsAbove ? null : product.zoneName,
            isFromSameCompanyAsAbove ? null : product.companyType,
            product.name,
            renderMediaType(product.mediaType, product.mediaDuration),
            product.companyID,
        ] : [
            isFromSameCompanyAsAbove
                ? null
                : (
                    <div style={{ display: 'flex', justifyContent: 'center' }}>
                        {/* {(isAuthorized && !eventInfo.free_login) && ( */}
                        {(isAuthorized && !eventInfo.free_exhibition && isWeakAuth === '') && (
                            <Checkbox
                                color="primary"
                                style={{ color: eventInfo?.settings_colors_viewer?.button_background_color?.common_button || navyColor }}
                                checked={!!selectedOrganizers[product.companyID]}
                                onChange={(e) => handleSetSelectedOrganizers(product.companyID, e.target.checked)}
                            />
                        )}

                        {(isAuthorized) && (
                            <Button
                                color="navy"
                                onClick={() => handleProductViewRouting(product.companyID)}
                                round
                                size="md"
                                buttonTextColor={eventInfo?.settings_colors_viewer?.button_text_color}
                                buttonBackgroundColor={eventInfo?.settings_colors_viewer?.button_background_color?.common_button}
                            >
                                {customText?.button_name?.direct_selection || intl.formatMessage({ id: 'directToDetailProduct' })}
                            </Button>
                        )}
                    </div>
                ),
            isFromSameCompanyAsAbove ? null : product.companyName,
            isFromSameCompanyAsAbove ? null : product.companyType,
            product.name,
            renderMediaType(product.mediaType, product.mediaDuration),
            product.companyID,
        ];

        if (    
              isAfterUsingEndXdays(
            	  eventInfo.edate,
            	  (customTimerctrl && customTimerctrl.hasOwnProperty("TC_exhprod_after") ) ? customTimerctrl.TC_exhprod_after : 30 
                 )
            || !isAuthorized
            || (!eventInfo.free_exhibition && (isWeakAuth || isWeakAuth === 'true'))
            ) {
            dataResult.shift();
        }
        return dataResult;
    };





    return (
        <>
            {!_.isEmpty(eventInfo) && (
                <div className={classes.wrapper}>
                    <GridItem xs={12}>
                        {!!(viewMode === VIEW_MODE.ICON_LIST && !companyList?.length) && (
                            <Typography
                                variant="h5"
                                align="center"
                                style={{ marginBottom: '8px', fontWeight: 'bold', fontSize: '20px' }}
                                customColor={eventInfo?.settings_colors_viewer?.contents_text_color}
                            >
                                { eventInfo.category.length > 1 ? "企業リストを読込中・・・" : intl.formatMessage({ id: 'exhibition.noExhibition' })}
                            </Typography>
                        )}
                        {   companyList && eventInfo.category.length > 1 ? renderByCategory() : renderMain()  }
                        {   ! companyList && eventInfo.category.length > 1 ? "企業リストが見つかりません。": ""  }
                        {   ! companyList && ( console.log("No data..L1957") )  }
                        { /*    companyList && companyList.length > 0 ? renderMain() : renderMain()    */  }
                        {renderBottomButton()}
                    </GridItem>
                    {
                        eventInfo.display_ads && (
                            <Advertisement
                                needSeparator={eventInfo.free_exhibition
                                    && viewMode === VIEW_MODE.ICON_LIST
                                    && isAuthorized}
                                customColor={eventInfo?.settings_colors_viewer}
                            />
                        )
                    }
                </div>
            )}
            <Snackbar
                open={errorDialog.isOpen}
                onClose={handleCloseErrorDialog}
                message={errorDialog.message}
            />
            <Observer {...options} />
            <Loader isLoading={isLoading} />
            {!_.isEmpty(eventInfo) && console.log(  eventInfo.category.length ) /* とくだテスト中 */}
        </>
    );
};

OrganizerList.defaultProps = {
    companyIDs: [],
    errorsGetProducts: {},
    errorsGetProductBigBooth: {},
    errorsGetProductSmallBooth: {},
    errorsGetProductStandardBooth: {},
    errorsGetProductGrandBooth: {},
    eventInfo: {},
    successGetProducts: undefined,
    successGetProductBigBooth: undefined,
    successGetProductSmallBooth: undefined,
    successGetProductStandardBooth: undefined,
    successGetProductGrandBooth: undefined,
    searchData: {},
    updateFavoriteSuccess: false,
    isWeakAuth: false || '',
    isCheckEvent: false,
    customText: {},


    getCustomText: () => {},
    clearCustomText: () => {},
    pageCompanyList: {},
    pageProductList: {},
    locale: 'ja',

/* ★★ */
    getSettingCustomTimerctrl: () =>{},
    clearCustomTimerctrl : () => {},
    customTimerctrl: {},

    fetchCategory: () => {},
    category: [],

};

OrganizerList.propTypes = {
    clearEventProducts: PropTypes.func.isRequired,
    clearEventProductsBigZone: PropTypes.func.isRequired,
    clearEventProductsSmallZone: PropTypes.func.isRequired,
    clearEventProductsStandardZone: PropTypes.func.isRequired,
    clearEventProductsGrandZone: PropTypes.func.isRequired,
    clearFavoriteCompanies: PropTypes.func.isRequired,
    customText: PropTypes.oneOfType([() => null, PropTypes.object]),
    companyIDs: PropTypes.arrayOf(PropTypes.number),
    errorsGetProducts: PropTypes.objectOf(PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.object,
    ])),
    errorsGetProductBigBooth: PropTypes.objectOf(PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.object,
    ])),
    errorsGetProductSmallBooth: PropTypes.objectOf(PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.object,
    ])),
    errorsGetProductStandardBooth: PropTypes.objectOf(PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.object,
    ])),
    errorsGetProductGrandBooth: PropTypes.objectOf(PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.object,
    ])),
    eventInfo: PropTypes.objectOf(PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
        PropTypes.bool,
        PropTypes.object,
    ])),
    getEventProducts: PropTypes.func.isRequired,
    getEventProductsBigZone: PropTypes.func.isRequired,
    getEventProductsSmallZone: PropTypes.func.isRequired,
    getEventProductsStandardZone: PropTypes.func.isRequired,
    getEventProductsGrandZone: PropTypes.func.isRequired,
    getFavoriteCompanies: PropTypes.func.isRequired,
    isAuthorized: PropTypes.bool.isRequired,
    isLoading: PropTypes.bool.isRequired,
    allProducts4Cate:PropTypes.objectOf(PropTypes.oneOfType([
        PropTypes.object,
        PropTypes.number,
        PropTypes.array,
    ])).isRequired,
    allProducts: PropTypes.objectOf(PropTypes.oneOfType([
        PropTypes.object,
        PropTypes.number,
        PropTypes.array,
    ])).isRequired,
    productsBigBooth: PropTypes.objectOf(PropTypes.oneOfType([
        PropTypes.object,
        PropTypes.number,
        PropTypes.array,
    ])).isRequired,
    productsSmallBooth: PropTypes.objectOf(PropTypes.oneOfType([
        PropTypes.object,
        PropTypes.number,
        PropTypes.array,
    ])).isRequired,
    productsStandardBooth: PropTypes.objectOf(PropTypes.oneOfType([
        PropTypes.object,
        PropTypes.number,
        PropTypes.array,
    ])).isRequired,
    productsGrandBooth: PropTypes.objectOf(PropTypes.oneOfType([
        PropTypes.object,
        PropTypes.number,
        PropTypes.array,
    ])).isRequired,
    successGetProducts: PropTypes.bool,
    successGetProductBigBooth: PropTypes.bool,
    successGetProductSmallBooth: PropTypes.bool,
    successGetProductStandardBooth: PropTypes.bool,
    successGetProductGrandBooth: PropTypes.bool,
    updateFavoriteCompanies: PropTypes.func.isRequired,
    fetchJobs: PropTypes.func.isRequired,
    fetchCategory: PropTypes.func.isRequired,
    category: PropTypes.oneOfType([() => null, PropTypes.array]),

    fetchZones: PropTypes.func.isRequired,
    setSelectedOrganizer: PropTypes.func.isRequired,
    clearSelectedOrganizers: PropTypes.func.isRequired,
    searchData: PropTypes.oneOfType([() => null, PropTypes.object]),
    clearSearchCondition: PropTypes.func.isRequired,
    clearUpdateFavorite: PropTypes.func.isRequired,
    updateFavoriteSuccess: PropTypes.bool,
    companyList: PropTypes.oneOfType([() => null, PropTypes.array]).isRequired,
    viewMode: PropTypes.bool.isRequired,
    setViewMode: PropTypes.func.isRequired,
    getCompaniesByEvent: PropTypes.func.isRequired,
    clearCompanyList: PropTypes.func.isRequired,
    isWeakAuth: PropTypes.oneOfType([() => null, PropTypes.string, PropTypes.bool]),
    isCheckEvent: PropTypes.bool,
    getCustomText: PropTypes.func,
    clearCustomText: PropTypes.func,
    pageCompanyList: PropTypes.oneOfType([() => null, PropTypes.object]),
    pageProductList: PropTypes.oneOfType([() => null, PropTypes.object]),
    locale: PropTypes.string,
    
/*  ★★　*/ 
    getSettingCustomTimerctrl: PropTypes.func,
    clearCustomTimerctrl: PropTypes.func,
    customTimerctrl: PropTypes.oneOfType([() => null, PropTypes.object]),    
};

export default OrganizerList;
